import { Component, EventEmitter, Injector, Input, OnInit, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { getDataScopeByPermission, isNotEmpty } from 'src/app/core/utils/common-functions';
import { PlantService } from 'src/app/features/transport-operation/services/plant-service';
import { SessionBaseComponent } from '../../session.base.component';

export const LAAS_PLANT_DROPDOWN_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => PlantDropdownComponent),
  multi: true
};

@Component({
  selector: 'laas-plant-dropdown',
  templateUrl: './plant-dropdown.component.html',
  styleUrls: ['./plant-dropdown.component.scss'],
  providers: [LAAS_PLANT_DROPDOWN_ACCESSOR],
  host: {
    'style': 'display: block;'
  }
})
export class PlantDropdownComponent extends SessionBaseComponent implements OnInit, ControlValueAccessor {

  @Input() divClass: string = '';
  @Input() labelClass: string = '';
  @Input() dropdownStyle: any = {};
  @Input() showLabel: boolean = false;
  @Input() showClear: boolean = true;
  @Input() showFilter: boolean = true;
  @Input() defaultSelectFirst: boolean = false;
  @Input() isSingle: boolean = false;
  @Input() isMultiple: boolean = false;
  @Input() plantDataList: any[] = [];
  @Input() plantData!: any;
  @Input() permissionCode!: PermissionConstants;

  @Output() onOptionDataChange: EventEmitter<any> = new EventEmitter();

  plantOptions: any[] = [];
  virtualScroll: boolean = false;
  
  // ControlValueAccessor 實作
  value: any;
  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};
  disabled = false;

  constructor(
    injector: Injector,
    private plantService: PlantService
  ) {
    super(injector);
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.initPlantOptions();
    this.virtualScroll = this.plantOptions && this.plantOptions.length > 30;
    this.changeDefaultSelectFirst();
  }

  private async initPlantOptions(): Promise<void> {
    this.plantService.getPlantOptions().subscribe({
      next: (result) => {
        var uniquePlantIds = Array.from(
          new Set(result.map((x: { plantId: any }) => x.plantId))
        );
        // 有設 dataScope, 且 orgId 非 null, 去過濾 plantId by orgId
        const curDataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
        if(isNotEmpty(curDataScopes) && !curDataScopes.some((dataScope: any) => dataScope?.orgId == null)) {
          uniquePlantIds = uniquePlantIds.filter(plantId => curDataScopes.some((dataScope: any) => dataScope?.orgId === plantId));
        }
        
        this.plantOptions = uniquePlantIds.map((plantId) => ({
          label: plantId,
          value: plantId,
        }));
        this.changeDefaultSelectFirst();
      },
    });
  }

  changeDefaultSelectFirst(): void {
    if (this.isSingle && this.defaultSelectFirst) {
      if (this.plantOptions.length > 0) {
        this.value = this.plantOptions[0].value;
        this.onChange(this.value);
      }
    }
  }

  onValueChange(event: any): void {
    this.value = event;
    this.onChange(this.value);
    this.onTouched();
    this.onOptionDataChange.emit(event);
  }

  // ControlValueAccessor 方法實作
  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
